import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface Props {
  title?: string;
  titleAlign?: 'left' | 'center' | 'right';
  hideBackButton?: boolean;
  url?: string;
}

export function TitleBar({ hideBackButton, title, titleAlign, url }: Props) {
  const navigate = useNavigate();

  const navigateBack = () => {
    if (url !== undefined) {
      navigate(url, { replace: true });
    } else {
      navigate(-1);
    }
  };

  const alignClass = titleAlign === 'center' ? 'text-center' : titleAlign === 'right' ? 'text-right' : 'text-left';

  return (
    <div
      className="flex items-center w-full min-h-[48px] pr-2 bg-bg-muted border-b border-border-default"
      style={{ paddingLeft: hideBackButton ? '8px' : '0px' }}
    >
      {!hideBackButton && (
        <button
          aria-label="Navigate back"
          onClick={navigateBack}
          className="flex items-center justify-center w-12 h-12 bg-transparent hover:bg-bg-subtle rounded transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
        </button>
      )}
      <div className="w-full">
        <span className={`text-lg ${alignClass}`}>{title}</span>
      </div>
    </div>
  );
}
